import { render, staticRenderFns } from "./FormatButtons.vue?vue&type=template&id=940fb434&"
import script from "./FormatButtons.vue?vue&type=script&lang=js&"
export * from "./FormatButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports